import React, { useState } from "react";
import { logo } from "../assets";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineMenu,
  AiOutlineClose,
  AiOutlineInstagram,
} from "react-icons/ai";

const Navbar = () => {
  const [toggle, setToggle] = useState(true); // true = menu zamknięte, false = menu otwarte
  const [submenu, setSubmenu] = useState(true); // true = submenu zamknięte, false = submenu otwarte
  const location = useLocation();
  
  // Ustalanie koloru na podstawie ścieżki
  const isHomePage = location.pathname === "/";
  const textColor = isHomePage ? 'text-white' : 'text-black';
  
  // Otwieranie/zamykanie submenu
  const subMenuHandler = () => {
    setSubmenu(!submenu);
  };

  // Zamknięcie menu
  const closeMenu = () => {
    setToggle(true);
  };

  // Zamknięcie submenu i menu głównego
  const handleSubmenuItemClick = () => {
    setSubmenu(true);
    closeMenu();
  };
  
  // Przełączanie stanu menu
  const toggleMenu = () => {
    setToggle(!toggle);
  };

  return (
    <div className={`fixed w-full z-[9999] ${isHomePage && toggle ? 'mix-blend-difference' : ''}`}>
      <div className={`${textColor} container mx-auto justify-between items-center flex text-[20px] py-5 px-5 md:px-0`}>
        <Link to="/">
          <div className={`w-[40px] ${isHomePage ? "invert" : ""}`}>
            <img src={logo} width='100%' height='100%' alt="Logo" />
          </div>
        </Link>
        
        {/* Menu desktopowe */}
        <div className="justify-between items-center flex-1 ml-20 hidden md:flex">
          <ul className="flex uppercase space-x-20 cursor-pointer">
            <li className="relative">
              <div onClick={subMenuHandler}>kolekcja</div>
              <div
                className={`${submenu ? "hidden" : "flex"} flex-col absolute p-3 z-[9999] ${textColor} w-auto whitespace-nowrap`}>
                <div onClick={handleSubmenuItemClick} className="mt-3">
                  <Link to="/materace">materace sleep well</Link>
                </div>
                <div onClick={handleSubmenuItemClick} className="mt-3">
                  <Link to="/lozka">łóżka live well</Link>
                </div>
                <span className="border-b-2 border-current"></span>
              </div>
            </li>
            <li>
              <Link to="/gallery">galeria</Link>
            </li>
            <li>
              <Link to="/salony">salony</Link>
            </li>
            <li>
              <Link to="/kontakt">kontakt</Link>
            </li>
          </ul>
          <div className="flex cursor-pointer text-2xl">
            <a href="https://www.instagram.com/sleepwell_livewell_/">
              <AiOutlineInstagram />
            </a>
          </div>
        </div>
        
        {/* Przycisk menu mobilnego */}
        <div className="flex md:hidden cursor-pointer">
          <div className="text-2xl" onClick={toggleMenu}>
            <AiOutlineMenu />
          </div>
        </div>
        
        {/* Menu mobilne */}
        <div
          className={`${
            toggle ? "hidden" : "flex"
          } justify-between fixed w-screen h-screen bg-white bg-opacity-90 left-0 top-0 text-left px-5 py-8 z-[10000]`}>
          <ul className="flex flex-col uppercase space-y-4 cursor-pointer text-black">
            <li>
              <Link to='/' onClick={closeMenu}>strona główna</Link>
            </li>
            <li>
              <Link to='/materace' onClick={closeMenu} className="font-bold">materace sleep well</Link>
            </li>
            <li>
              <Link to='/lozka' onClick={closeMenu} className="font-bold">łóżka live well</Link>
            </li>
            <li>
              <Link to="/gallery" onClick={closeMenu}>galeria</Link>
            </li>
            <li>
              <Link to="/salony" onClick={closeMenu}>salony</Link>
            </li>
            <li>
              <Link to="/kontakt" onClick={closeMenu}>kontakt</Link>
            </li>
            <li className="flex justify-left text-3xl">
              <a href="https://www.instagram.com/sleepwell_livewell_/" onClick={closeMenu}>
                <AiOutlineInstagram />
              </a>
            </li>
          </ul>
          <div
            className="text-black flex text-2xl cursor-pointer"
            onClick={closeMenu}>
            <AiOutlineClose />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;